import { Box } from "@mui/material"
import SettingsStringOptionSelector from "../../../settings/SettingsStringOptionSelector"
import SettingsBooleanOptionSelector from "../../../settings/SettingsBooleanOptionSelector"


const RslBeginnerSettingsTracker = () => {


    return <Box>
        <SettingsStringOptionSelector options={["Vanilla", "Regional", "Anywhere"]} settingName="Shuffle CMG Keys" />
        <SettingsStringOptionSelector options={["Remove", "Vanilla", "Dungeon", "Regional", "Anywhere"]} settingName="Shuffle Silver Rupees" />
        <SettingsStringOptionSelector options={["Open", "Adult Only", "Close"]} settingName="Fountain" />
        <SettingsStringOptionSelector options={["Open (0)", "Fast (1)", "Vanilla (4)"]} settingName="Fortress" />
        <SettingsStringOptionSelector options={["Simple", "All"]} settingName="Shuffle Interrior" />
        <SettingsBooleanOptionSelector  settingName="Shuffle Grottos" />
        <SettingsBooleanOptionSelector settingName="Shuffle Dungeons" />
        <SettingsBooleanOptionSelector  settingName="Shuffle Bosses" />
    </Box>
}

export default RslBeginnerSettingsTracker